export const initialState = {
  rawat_jalan: {
    list: [],
    total_data: 0,
  },
  antrean_jkn: {
    list: [],
    total_data: 0,
  },
  loading: false,
  loading_antrean_jkn: false,
};

export const actions = {
  CHANGE_RAWAT_JALAN: "CHANGE_RAWAT_JALAN",
  CHANGE_LOADING: "CHANGE_LOADING",
  CHANGE_ANTREAN_JKN: "CHANGE_ANTREAN_JKN",
  CHANGE_LOADING_ANTREAN_JKN: "CHANGE_LOADING_ANTREAN_JKN",
};
